// DO NOT EDIT this file was generated with scripts/IntrinsicElements
import * as React from "react";

export interface FuroResizer extends React.HTMLAttributes<HTMLElement> {
  // no events defined.
  // properties

  // attributes

  /**
   * add a handle to the left side.
   */
  lefthandle?: void;

  /**
   * Set the maximal width of the resizer
   */
  maxwidth?: number | undefined;

  /**
   * Set the minimal width of the resizer
   */
  minwidth?: number | undefined;

  /**
   * remember the size after resizing.
   * Give the id for the rememberer, you can use the id on different views
   */
  remember?: string | undefined;

  /**
   * add a handle to the right side.
   */
  righthandle?: void;
}

declare module "react" {
  namespace JSX {
    interface IntrinsicElements {
      /**
       * `furo-resizer`
       * container which let you resize its width.
       *
       * Double-click on the handler to reset the width.
       * You need a counter part which flexes.
       *
       *
       * ```html
       * <furo-horizontal-flex>
       * <div flex> the flexible part </div>
       * <!-- you have to set at leas one handle to resize the content -->
       * <furo-resizer righthandle remember="logv" minwidth="280" maxwidth="780">
       * <some-content></some-content>
       * </furo-resizer>
       * </furo-horizontal-flex>
       * ```
       */
      "furo-resizer": FuroResizer;
    }
  }
}
